<template>
    <div>
        <div>
            <vs-row v-if="!embedded_mode" class="mb-2">
                <vs-col class="pl-0 pr-1" vs-xs="12" vs-sm="12" vs-lg="12">
                    <vs-input v-model="filters.search" placeholder="Type to search" class="w-full" />
                </vs-col>
            </vs-row>
            <vs-row v-if="!embedded_mode" class="mb-base">
                <vs-col vs-xs="12" vs-sm="4" vs-lg="3" class="pl-0 pr-2">
                    <InputSelect :model.sync="filters.corporate_action_type" label="Corporate Action Type"
                        placeholder="Type to search" :options="corporate_action_type_options" :multiple="false" />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="3" class="pl-0 pr-2">
                    <SelectForeign :model.sync="filters.share" label="Filter by Share" placeholder="Type to Search"
                        :multiple="false" :load_initial="true" :label_keys="['name',]" label_class="mb-0"
                        input_class="mt-0 bg-white" :show_id_in_label="true" list_length="10000"
                        :endpoint="$store.state.apiendpoints.share_list" :use_id_as_value="true" />
                </vs-col>
            </vs-row>
            <vs-table :data="results">
                <vs-tr>
                    <vs-th>ID</vs-th>
                    <vs-th>Corporate Action Type</vs-th>
                    <vs-th>Share</vs-th>
                    <vs-th>Action Info</vs-th>
                    <vs-th>Applicable Date</vs-th>
                    <vs-th></vs-th>
                </vs-tr>
                <vs-tr v-for="(item, index) in results" :key="index">
                    <vs-td>{{ item.id }}</vs-td>
                    <vs-td>
                        <FormatText :text="item.corporate_action_type" format="select"
                            :kwargs="corporate_action_type_options" />
                    </vs-td>
                    <!-- <vs-td>{{ item.corporate_action_type }}</vs-td> -->
                    <vs-td>{{ item.share['name'] }}</vs-td>
                    <vs-td v-if="item.corporate_action_type == 'bonus'">
                        <span v-if="item.action_info['bonus_ratio']">
                            Bonus Ratio - {{ item.action_info['bonus_ratio']['numerator'] }}:{{
                                item.action_info['bonus_ratio']['denominator'] }}
                        </span>
                        <span v-else>Bonus Ratio</span>
                    </vs-td>
                    <vs-td v-else-if="item.corporate_action_type == 'split'">Split Factor - {{
                        item.action_info['split_factor'] }}
                    </vs-td>
                    <vs-td v-else-if="item.corporate_action_type == 'demerge'">Demerge</vs-td>
                    <vs-td v-else-if="item.corporate_action_type == 'merge'">Merge</vs-td>
                    <vs-td>
                        <template v-if="item.applicable_date">
                            <FormatText :text="item.applicable_date" format="date" />
                        </template>
                        <template v-else>
                            -
                        </template>
                    </vs-td>
                    <vs-td class="text-right">
                        <vs-button class="ml-3" color="primary" type="filled" @click="redirect(item)"
                            size="small">Edit</vs-button>
                        <vs-button class="ml-3" color="danger" type="filled" size="small"
                            @click="doDelete(item, index)">Delete</vs-button>
                    </vs-td>
                </vs-tr>
            </vs-table>
        </div>
        <vs-row v-if="total_items" class="mt-3">
            <vs-pagination :total="total_pages" v-model="current_page" goto class="mx-auto"></vs-pagination>
        </vs-row>
    </div>
</template>

<script>
import { Request } from '../../utils/requests'
export default {
    props: {
        embedded_mode: {
            default: false
        },
        embedded_filters: {
            default: null
        }
    },
    data() {
        let offset = parseInt(this.$route.query.offset || 0)
        let limit = parseInt(this.$route.query.limit || 20)

        let current_page = Math.ceil((offset + limit) / limit)

        return {

            results: [],

            next_url: null,
            loading: false,
            total_items: null,
            current_page: current_page,
            corporate_action_type_options: [
                { value: "bonus", label: "Bonus Action" },
                { value: "split", label: "Split Action" },
                { value: "demerge", label: "Demerge Action" },
                { value: "merge", label: "Merge Action" },
            ],
            filters: {
                ordering: this.$route.query.ordering || [],
                search: this.$route.query.search || null,
                offset: offset,
                limit: limit,
                corporate_action_type: null,
                share: null
            }
        }
    },
    computed: {
        total_pages() {
            if (this.total_items == 0 || this.filters.limit == 0) return 1
            return Math.ceil(this.total_items / this.filters.limit)
        }
    },
    mounted() {
        this.timer = null
        this.init()
    },
    watch: {
        filters: {
            deep: true,
            handler(newV) {
                if (this.current_page == null) return

                if (this.timer) clearTimeout(this.timer)

                this.timer = setTimeout(() => {
                    console.log(newV)
                    this.$router.push({ name: this.$route.name, query: newV })
                }, 800)
            }
        },
        '$route.query'(newV) {
            this.load_data(newV)
        },
        current_page(newV, oldV) {
            if (newV == oldV) return
            this.filters.offset = (newV - 1) * this.filters.limit
        }
    },
    methods: {
        init() {
            this.load_data(this.filters)
        },
        calculate_page() {
            if (this.filters.offset == 0)
                this.current_page = 1
            else
                this.current_page = Math.ceil(this.filters.offset / this.filters.limit)
        },
        load_data(filters = null, next = false) {

            if (next && !this.next_url && !filters) return
            let url = (next && !filters) ? this.next_url : this.$store.state.apiendpoints.corporate_action

            let payload = null
            if (filters)
                payload = this.deepclone(filters)
            else
                payload = {}

            if ('ordering' in payload)
                if (Array.isArray(payload.ordering))
                    payload.ordering = payload.ordering.join(",")

            if (this.embedded_mode && this.embedded_filters) {
                payload = { ...payload, ...this.embedded_filters }
            }

            this.loading = true
            this.$vs.loading()

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.results = res.results
                    this.total_items = res.count
                    this.next_url = res.next
                    this.loading = false
                    this.$vs.loading.close()
                },
                (err) => {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: 'An Error Occured. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    if (!next)
                        this.$router.push("/");
                    this.loading = false
                    this.$vs.loading.close()
                }
            )
        },
        doDelete(item, index) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Are you sure?`,
                text: 'This will delete the Corporate Action. This action cannot be undone.',
                accept: () => this._doDelete(item, index)
            })
        },
        _doDelete(item, index) {
            let url = this.$store.state.apiendpoints.corporate_action_rud + item.id + "/"

            item.submit_disabled = true

            Request(this, 'DELETE', url).then(
                (res) => {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Deleted',
                        text: 'Deleted Successfully',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    })
                    item.submit_disabled = false
                    this.results.splice(index, 1)
                },
                (err) => {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: 'An Error Occured. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    item.submit_disabled = false
                }
            )
        },
        redirect(item) {
            if (item.corporate_action_type == 'bonus') {
                this.$router.push({ name: 'edit-bonus-corporate-action', params: { bonus_id: item.id } })
            } else if (item.corporate_action_type == 'split') {
                this.$router.push({ name: 'edit-split-corporate-action', params: { split_id: item.id } })
            } else if (item.corporate_action_type == 'demerge') {
                this.$router.push({ name: 'edit-demerge-corporate-action', params: { demerge_id: item.id } })
            } else if (item.corporate_action_type == 'merge') {
                this.$router.push({ name: 'edit-merge-corporate-action', params: { merge_id: item.id } })
            }
        }
    }
}
</script>
<style lang="scss">
.v-select {
    background: white;
}
</style>